//@ts-check
import isFile from './isFile';
import getFolderPath from './getFolderPath';
/**
 * @type {import("./types").getParentFolderPathType}
 */

export default (function (path) {
  if (isFile(path)) return getFolderPath(path);
  var folderPath = getFolderPath(path);
  var segments = folderPath.split('/');
  segments.pop();
  return segments.join('/');
});